module.exports = __webpack_public_path__ + "img/4.e96ecbb6.jpg";